import { useMemo } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faListOl } from '@fortawesome/pro-solid-svg-icons/faListOl'
import { faSync } from '@fortawesome/pro-solid-svg-icons/faSync'
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons/faInfoCircle'
import { useTranslation } from 'react-i18next'
import { Tooltip } from 'antd'
import { IQuestionBankSection } from 'interfaces/questionBank'
import { calculateSectionTotals } from 'helpers/evaluations/calculateSectionTotals'
import { Wrapper } from './styled'

interface IProps {
  section: IQuestionBankSection
}

const Information = ({ section }: IProps) => {
  const { t } = useTranslation()
  const translationPrefix = 'administration.blocks.type.questionBankV2.sections'
  const totalScore = useMemo(
    () => calculateSectionTotals(section).score,
    [section]
  )

  return (
    <Wrapper>
      <span>
        <FontAwesomeIcon icon={section.randomOrder ? faSync : faListOl} />
        {`${
          section.randomOrder ? `${section.randomQuestionsToDisplay} ` : ''
        }${t(
          `${translationPrefix}.${
            section.randomOrder ? 'randomOrder.title' : 'fixedOrder.title'
          }`
        )}`}
        <Tooltip
          getPopupContainer={() =>
            document.getElementById('lmsPage') as HTMLElement
          }
          title={
            <div style={{ width: '200px' }}>
              {t(
                `${translationPrefix}.${
                  section.randomOrder
                    ? 'randomOrder.description'
                    : 'fixedOrder.description'
                }`
              )}
            </div>
          }
        >
          <FontAwesomeIcon icon={faInfoCircle} />
        </Tooltip>
      </span>
      <Tooltip
        getPopupContainer={() =>
          document.getElementById('lmsPage') as HTMLElement
        }
        title={
          <div style={{ width: '200px' }}>
            {t(
              `administration.blocks.type.questionBankV2.evaluationScore.totalScore.description`
            )}
          </div>
        }
      >
        <span>
          {`${totalScore} ${t(`${translationPrefix}.score`)}`}{' '}
          <FontAwesomeIcon icon={faInfoCircle} />
        </span>
      </Tooltip>
    </Wrapper>
  )
}

export default Information
